import React from 'react';

interface NavigateHelperComponentProps {
    target: string;
}
export const NavigateHelperComponent: React.FC<NavigateHelperComponentProps> = ({ target }) => {
    window.location.href = target;
    return <></>;
};
